import { schema as schemas } from 'normalizr'
import { CallApi } from '@signavio/kraken'

import { Group } from '../../../types'

export const collection = 'groups'

export const schema = new schemas.Entity(collection)

export const fetch =
  (callApi: CallApi, apiBase: string) =>
  ({ id }: { id: string }) =>
    callApi(`${apiBase}/groups/${id}`, schema)

export const create =
  (callApi: CallApi, apiBase: string) => (_: unknown, body: Group) =>
    callApi(`${apiBase}/groups`, schema, { method: 'POST', body })

export const update =
  (callApi: CallApi, apiBase: string) =>
  ({ id }: { id: string }, body: Group) =>
    callApi(`${apiBase}/groups/${id}`, schema, { method: 'PUT', body })

export const remove =
  (callApi: CallApi, apiBase: string) =>
  ({ id }: { id: string }) => {
    return callApi(`${apiBase}/groups/${id}`, schema, { method: 'DELETE' })
  }
